"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeCycle = exports.LifecycleKeys = void 0;
const AppWillMountHandlerSym = Symbol('AppWillMountHandler');
const AppWillLoadPageHandlerSym = Symbol('AppWillLoadPageHandler');
const AppWillRenderFirstPageHandlerSym = Symbol('AppWillRenderFirstPageHandler');
const AppDidLoadPageHandlerSym = Symbol('AppDidLoadPageHandler');
const PageDidLoadHandlerSym = Symbol('PageDidLoadHandler');
const PageWillMountHandlerSym = Symbol('PageWillMountHandler');
const PageDidMountHandlerSym = Symbol('PageDidMountHandler');
const PageWillUnmountHandlerSym = Symbol('PageWillUnmountHandler');
const PageDidUnmountHandlerSym = Symbol('PageDidUnmountHandler');
const AppDidMountHandlerSym = Symbol('AppDidMountHandler');
const AppWillUnmountHandlerSym = Symbol('AppWillUnmountHandler');
exports.LifecycleKeys = {
    [AppWillMountHandlerSym]: true,
    [AppWillLoadPageHandlerSym]: true,
    [AppWillRenderFirstPageHandlerSym]: true,
    [AppDidLoadPageHandlerSym]: true,
    [PageDidLoadHandlerSym]: true,
    [PageWillMountHandlerSym]: true,
    [PageDidMountHandlerSym]: true,
    [PageWillUnmountHandlerSym]: true,
    [PageDidUnmountHandlerSym]: true,
    [AppDidMountHandlerSym]: true,
    [AppWillUnmountHandlerSym]: true,
};
exports.LifeCycle = {
    // Site features events
    AppWillMountHandler: AppWillMountHandlerSym,
    AppWillLoadPageHandler: AppWillLoadPageHandlerSym,
    AppWillRenderFirstPageHandler: AppWillRenderFirstPageHandlerSym,
    AppDidLoadPageHandler: AppDidLoadPageHandlerSym,
    AppDidMountHandler: AppDidMountHandlerSym,
    AppWillUnmountHandler: AppWillUnmountHandlerSym,
    // Page features events
    PageDidLoadHandler: PageDidLoadHandlerSym,
    PageWillMountHandler: PageWillMountHandlerSym,
    PageDidMountHandler: PageDidMountHandlerSym,
    PageWillUnmountHandler: PageWillUnmountHandlerSym,
    PageDidUnmountHandler: PageDidUnmountHandlerSym,
};
//# sourceMappingURL=LifeCycle.js.map